import {colors} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: row;
  background: ${colors.white};
  border-bottom: ${colors.gray2} 1px solid;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 1rem 4rem;
  z-index: 2;
`;

const LeftRegion = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4rem;
`;

const RightRegion = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.4rem;
  margin-left: auto;
`;

export {Wrapper, LeftRegion, RightRegion};
